"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutcodeLocationAttributes$ = exports.OutcodeLocationAttributes$outboundSchema = exports.OutcodeLocationAttributes$inboundSchema = exports.AreaType$ = exports.AreaType$outboundSchema = exports.AreaType$inboundSchema = exports.AreaType = void 0;
exports.outcodeLocationAttributesToJSON = outcodeLocationAttributesToJSON;
exports.outcodeLocationAttributesFromJSON = outcodeLocationAttributesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const locationpolygon_js_1 = require("./locationpolygon.js");
exports.AreaType = {
    PostcodeOutcode: "POSTCODE_OUTCODE",
    PostcodeSector: "POSTCODE_SECTOR",
    Postcode: "POSTCODE",
};
/** @internal */
exports.AreaType$inboundSchema = z
    .nativeEnum(exports.AreaType);
/** @internal */
exports.AreaType$outboundSchema = exports.AreaType$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AreaType$;
(function (AreaType$) {
    /** @deprecated use `AreaType$inboundSchema` instead. */
    AreaType$.inboundSchema = exports.AreaType$inboundSchema;
    /** @deprecated use `AreaType$outboundSchema` instead. */
    AreaType$.outboundSchema = exports.AreaType$outboundSchema;
})(AreaType$ || (exports.AreaType$ = AreaType$ = {}));
/** @internal */
exports.OutcodeLocationAttributes$inboundSchema = z.object({
    agg_polygons: z.nullable(z.array(z.string())),
    area_type: z.nullable(exports.AreaType$inboundSchema),
    description: z.nullable(z.string()),
    description_1: z.nullable(z.string()),
    display_name: z.nullable(z.string()),
    epsg_27700_polygon: z.nullable(locationpolygon_js_1.LocationPolygon$inboundSchema),
    epsg_27700_polygon_simplified: z.nullable(locationpolygon_js_1.LocationPolygon$inboundSchema),
    epsg_4326_polygon: z.nullable(locationpolygon_js_1.LocationPolygon$inboundSchema),
    epsg_4326_polygon_simplified: z.nullable(locationpolygon_js_1.LocationPolygon$inboundSchema),
    name: z.nullable(z.string()),
    polygon_id: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "agg_polygons": "aggPolygons",
        "area_type": "areaType",
        "description_1": "description1",
        "display_name": "displayName",
        "epsg_27700_polygon": "epsg27700Polygon",
        "epsg_27700_polygon_simplified": "epsg27700PolygonSimplified",
        "epsg_4326_polygon": "epsg4326Polygon",
        "epsg_4326_polygon_simplified": "epsg4326PolygonSimplified",
        "polygon_id": "polygonId",
    });
});
/** @internal */
exports.OutcodeLocationAttributes$outboundSchema = z.object({
    aggPolygons: z.nullable(z.array(z.string())),
    areaType: z.nullable(exports.AreaType$outboundSchema),
    description: z.nullable(z.string()),
    description1: z.nullable(z.string()),
    displayName: z.nullable(z.string()),
    epsg27700Polygon: z.nullable(locationpolygon_js_1.LocationPolygon$outboundSchema),
    epsg27700PolygonSimplified: z.nullable(locationpolygon_js_1.LocationPolygon$outboundSchema),
    epsg4326Polygon: z.nullable(locationpolygon_js_1.LocationPolygon$outboundSchema),
    epsg4326PolygonSimplified: z.nullable(locationpolygon_js_1.LocationPolygon$outboundSchema),
    name: z.nullable(z.string()),
    polygonId: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        aggPolygons: "agg_polygons",
        areaType: "area_type",
        description1: "description_1",
        displayName: "display_name",
        epsg27700Polygon: "epsg_27700_polygon",
        epsg27700PolygonSimplified: "epsg_27700_polygon_simplified",
        epsg4326Polygon: "epsg_4326_polygon",
        epsg4326PolygonSimplified: "epsg_4326_polygon_simplified",
        polygonId: "polygon_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var OutcodeLocationAttributes$;
(function (OutcodeLocationAttributes$) {
    /** @deprecated use `OutcodeLocationAttributes$inboundSchema` instead. */
    OutcodeLocationAttributes$.inboundSchema = exports.OutcodeLocationAttributes$inboundSchema;
    /** @deprecated use `OutcodeLocationAttributes$outboundSchema` instead. */
    OutcodeLocationAttributes$.outboundSchema = exports.OutcodeLocationAttributes$outboundSchema;
})(OutcodeLocationAttributes$ || (exports.OutcodeLocationAttributes$ = OutcodeLocationAttributes$ = {}));
function outcodeLocationAttributesToJSON(outcodeLocationAttributes) {
    return JSON.stringify(exports.OutcodeLocationAttributes$outboundSchema.parse(outcodeLocationAttributes));
}
function outcodeLocationAttributesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.OutcodeLocationAttributes$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'OutcodeLocationAttributes' from JSON`);
}
//# sourceMappingURL=outcodelocationattributes.js.map